var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { keyframes } from '@chakra-ui/react';
var gradientMove = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% { background-position: 100% 0%; }\n  25% { background-position: 75% 25%; }\n  50% { background-position: 50% 50%; }\n  75% { background-position: 25% 75%; }\n  100% { background-position: 0% 90%; }\n"])));
var breathing = keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  0% { transform: scale(0.9); }\n  25% { transform: scale(1.2); }\n  60% { transform: scale(1.1); }\n  100% { transform: scale(0.9); }\n"])));
var appear = keyframes(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  0% { transform: scale(0); }\n  100% { transform: scale(1); }\n"])));
var disappear = keyframes(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  0% { transform: scale(1); }\n  100% { transform: scale(0); }\n"])));
var shiftRight = keyframes(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  0% { transform: translateX(0px); }\n  100% { transform: translateX(16px); }\n"])));
export var cssAnimations = {
  breathing: {
    keyframes: breathing,
    animation: '2s linear infinite'
  },
  gradientMove: {
    keyframes: gradientMove,
    animation: '5s linear'
  },
  appear: {
    keyframes: appear,
    animation: '0.6s ease infinite'
  },
  disappear: {
    keyframes: disappear,
    animation: '0.6s ease infinite'
  },
  shiftRight: {
    keyframes: shiftRight,
    animation: '0.6s ease infinite'
  }
};
//# sourceMappingURL=animations.js.map